import type * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
export type SampleParentTileFragment = { id: number | null, name: string | null, description: string | null, sampleCount: number, parentType: { name: string } };

export type MinimalSampleTileFragment = { id: number, name: string | null, locked: boolean | null, hidden: boolean, deleted: boolean | null, type: { id: number, name: string } | null };

export const SampleParentTileFragmentDoc = gql`
    fragment SampleParentTile on Parent {
  id
  name
  description
  sampleCount
  parentType {
    name
  }
}
    `;
export const MinimalSampleTileFragmentDoc = gql`
    fragment MinimalSampleTile on Sample {
  id
  name
  type {
    id
    name
  }
  locked
  hidden
  deleted
}
    `;